<div>
    @if (edit) {
        <mat-form-field>
            <input matInput [value]="collection.sharedLink?.url" readonly>
        </mat-form-field>


       <!-- <mat-checkbox [(ngModel)]="active" class="mb-3"><mat-label>{{ 'collection.share.link.activation'| translate }}</mat-label></mat-checkbox>-->
    }

</div>
@if (error) {
    <div class="error">
        {{ 'collection.share.link.error'|translate }}
    </div>
}

    <form>
        <mat-form-field>
            <mat-label>{{ 'collection.share.link.permission'| translate }}</mat-label>
            <mat-select [(ngModel)]="permission" name="permission">
                <mat-option value="download">{{ 'collection.access.download'|translate }}</mat-option>
                <mat-option value="view">{{ 'collection.access.view'|translate }}</mat-option>
            </mat-select>
        </mat-form-field>

        <div class="row">
            <div class="col-6">
                <mat-form-field>
                    <mat-label>{{ 'collection.share.link.validFrom'| translate }}</mat-label>
                    <input matInput [matDatepicker]="fromPicker" [(ngModel)]="validFrom" name="validFrom">
                    <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #fromPicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>{{ 'collection.share.link.validfromtime'|translate }}</mat-label>
                    <input #fromTimeInput matInput [matTimepicker]="fromTimePicker" [(ngModel)]="validFrom" [ngModelOptions]="{updateOn: 'blur'}" name="validFromTime">
                    <mat-timepicker-toggle matIconSuffix [for]="fromTimePicker"></mat-timepicker-toggle>
                    <mat-timepicker #fromTimePicker></mat-timepicker>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>{{ 'collection.share.link.validUntil'| translate }}</mat-label>
                    <input matInput [matDatepicker]="untilPicker" [(ngModel)]="validUntil" name="validUntil">
                    <mat-datepicker-toggle matIconSuffix [for]="untilPicker"></mat-datepicker-toggle>
                    <mat-datepicker #untilPicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>{{ 'collection.share.link.validuntiltime'|translate }}</mat-label>
                    <input matInput [matTimepicker]="untilTimePicker" [(ngModel)]="validUntil" [ngModelOptions]="{updateOn: 'blur'}" name="validUntilTime">
                    <mat-timepicker-toggle matIconSuffix [for]="untilTimePicker"></mat-timepicker-toggle>
                    <mat-timepicker #untilTimePicker></mat-timepicker>
                </mat-form-field>
            </div>
        </div>


    </form>

<footer>
    <div class="btn-row">
        <div>
            <button mat-button type="button" (click)="close()">{{ 'button.cancel'|translate }}</button>
        </div>
       <div>
           <button mat-raised-button class="me-2" type="button" (click)="revoke()">
               {{ 'collection.action.revokepublic'|translate }}
           </button>
           <button mat-raised-button type="submit" (click)="confirm()">
               {{ 'button.save'|translate }}
           </button>
       </div>

    </div>
</footer>
